import { render, staticRenderFns } from "./ProductBannerTheme1.vue?vue&type=template&id=22fde658&scoped=true"
import script from "./ProductBannerTheme1.vue?vue&type=script&lang=js"
export * from "./ProductBannerTheme1.vue?vue&type=script&lang=js"
import style0 from "./ProductBannerTheme1.vue?vue&type=style&index=0&id=22fde658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fde658",
  null
  
)

export default component.exports